/* eslint-disable */
import { Button, Switch } from "antd";
import { useEffect, useState } from "react";
import { useMatStyles } from "./style";
import { customBaseUrl, httpGet, httpPost, httpPut } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AntDropdown from "../../components/CustomDropdown/AntDropdown";
import ExportData from "../WayaOfficial/modal/exportData";
import Swal from "sweetalert2";
import moment from "moment";
import { ExportOutlined } from "@ant-design/icons";
import CreateCardProduct from "./modals/createCardProduct";
import UpdateCardProduct from "./modals/UpdateCardProduct"; // Import new modal
import { ArrowBack } from "@mui/icons-material";
import { CSVLink } from "react-csv";

const Container = `styled.div`;

const CardProducts = ({ setShowProducts }) => {
  const [metaData, setMetaData] = useState(0);
  const [pagination, setPagination] = useState({ current: 0, pageSize: 10 });
  const [products, setProducts] = useState([]);
  const [showExport, setShowExport] = useState(false);
  const [showCreateCardProduct, setShowCreateCardProduct] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false); // state for update modal
  const [updateData, setUpdateData] = useState(null); // state for data to update
  const styles = useMatStyles();

  const handleToggleActiveProduct = async (row, checked) => {
    showLoader();
    const endpoint = checked
      ? `${customBaseUrl.cardUrl}/cms/admin/activate-card-product/${row.id}`
      : `${customBaseUrl.cardUrl}/cms/admin/deactivate-card-product/${row.id}`;
    
    let res = await httpPut(endpoint);
    hideLoader();
    
    const isSuccess = res && (
      res.status === true || 
      res.respCode === 0 || 
      (res.message && (
        res.message.toLowerCase().includes('success') || 
        res.message.toLowerCase().includes('activated') || 
        res.message.toLowerCase().includes('deactivated')
      ))
    );

    if (isSuccess) {
      Swal.fire('Updated', `Card product successfully ${checked ? 'activated' : 'deactivated'}`, 'success');
      getProducts();
    } else {
      Swal.fire('Error', res?.message || 'Failed to update status', 'error');
    }
  };

  const handleOpenUpdateModal = (row) => {
    setUpdateData(row);
    setShowUpdateModal(true);
  };

  const columns = [

    {
      field: 'productName',
      headerName: 'Product Name',
      width: 250,
      //    headerClassName: styles.tableHeader

    },
    {
      field: 'chargeFee',
      headerName: 'Charge Fee',
      width: 250,
      //    headerClassName: styles.tableHeader

    },
    {
      field: 'maintenanceFee',
      headerName: 'Maintenance Fee',
      width: 250,
      //    headerClassName: styles.tableHeader

    },
    {
      field: 'active',
      headerName: 'Status',
      width: 180,
      renderCell: ({ row }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Switch
            checked={row?.active}
            onChange={(checked) => handleToggleActiveProduct(row, checked)}
            size="small"
          />
          <span style={{
            color: row?.active ? '#2e7d32' : '#d32f2f',
            background: row?.active ? '#edf7ed' : '#fdeded',
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: 600
          }}>
            {row?.active ? 'Active' : 'Inactive'}
          </span>
        </div>
      )
    },

    {
      field: 'createdAt',
      headerName: "Date",
      width: 150,
      // headerClassName: styles.tableHeader,
      renderCell: ({ row }) => moment(row?.createdAt).format('DD-MM-YYYY')
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: ({ row }) => (
        <Button onClick={() => handleOpenUpdateModal(row)}>
          Edit
        </Button>
      ),
    },
  ];


  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    // await getProducts(newPage, newPage, pagination.pageSize);

  };
  const handleChangeRowsPerPage = async (e) => {
    setPagination({ ...pagination, current: 0, pageSize: e });
    //await getProducts(e,1, e);
  };

  const getProducts = async (e, page, size) => {
    e?.preventDefault();
    showLoader();
    const pages = page === 0 ? 0 : page ? page : pagination.current;
    const limit = size ? size : pagination.pageSize;

    let request = await httpGet(
      `${customBaseUrl.cardUrl}/cms/cards/list/card-product`, null, true, false, null, true
    );
    if (request?.status) {
      hideLoader();
      setProducts(request?.data)
      setMetaData(request?.data?.length);
    } else {
      hideLoader();

    }


  };


  useEffect(() => {

  }, []);
  useEffect(() => {
    getProducts()
  }, [pagination?.pageSize, pagination.current]);

  return (
    <>

      <Container>

        <div className={styles.searchRow}>
          <div onClick={() => setShowProducts(false)}>
            <ArrowBack />
          </div>
          <div />
          <div />

          <div>
            <Button
              size="medium"
              style={{ background: "#27AE60", fontSize: "12px", color: "#fff" }}
            >
              <CSVLink
                data={products?.length > 0 ? products : []}
                style={{
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none"
                }}
                filename={`cards product Type.csv`}
                onClick={(event, done) => {
                  //event.preventDefault();
                  // handleFilterOperation();
                  //done()           
                }}
              >
                Export
              </CSVLink>
            </Button>
          </div>
          <div className={styles.grow} />

          <Button
            onClick={() => setShowCreateCardProduct(true)}
            className={styles.updateButton} size="medium">
            Create New Product
          </Button>
        </div>

        <div style={{ height: 800, width: "100%" }}>
          {products?.length > 0 && <DataGrid
            className={styles.table}
            density="comfortable"
            rows={products}
            columns={columns}
            page={pagination.current}
            pageSize={pagination.pageSize}
            onPageSizeChange={(newPageSize) =>
              handleChangeRowsPerPage(newPageSize)
            }
            // paginationMode="server"
            onPageChange={(newPage) => handleChangePage(newPage)}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            pagination
            components={{ Toolbar: GridToolbar }}
            rowCount={metaData}
          />}
        </div>
        {showCreateCardProduct ? (
          <CreateCardProduct
            showModal={showCreateCardProduct}
            hideModal={setShowCreateCardProduct}
            getProducts={getProducts}
          />
        ) : (
          ""
        )}
        {showUpdateModal && (
          <UpdateCardProduct
            showModal={showUpdateModal}
            hideModal={() => setShowUpdateModal(false)}
            getProducts={getProducts}
            initialData={updateData}
          />
        )}
      </Container>
      {showExport &&
        <ExportData showModal={showExport} hideModal={setShowExport} dataList={products} file={"KYC users tier "} />
      }
    </>
  );
};
export default CardProducts;
const gridStyle = {
  width: "23%",
  textAlign: "left",
  backgroundColor: "#fff",
  padding: "24px 10px 24px 12px",
  fontWeight: "bold",
  marginLeft: "10px",
};

const tool = {
  display: "flex",
  borderRadius: "250px",
  justifyContent: "space-between",
  marginBottom: "30px",
};
